export default "__VITE_ASSET__Dmt7_Ywe__";